export const formFieldModelCreate = {
    formId: 'createAusenciaEmpleadoForm',
    formField: {
        empleado_id: {
            name: 'empleado_id',
            label: 'Empleado',
            errorMsg: 'El empleado es requerido'
        },
        absence_type: {
            name: 'absence_type',
            label: 'Tipo de Ausencia',
            errorMsg: 'El tipo de ausencia es requerido'
        },
        start_date: {
            name: 'start_date',
            label: 'Fecha de Inicio',
            errorMsg: 'La fecha de inicio es requerida'
        },
        end_date: {
            name: 'end_date',
            label: 'Fecha de Fin',
            errorMsg: 'La fecha de fin es requerida'
        },
        description: {
            name: 'description',
            label: 'Descripción',
            errorMsg: 'La descripción es requerida'
        },
        certificate_url: {
            name: 'certificate_url',
            label: 'Documento (Opcional)'
        },
        approval_status: {
            name: 'approval_status',
            label: 'Estado',
            errorMsg: 'El estado del registro es requerido'
        }
    }
};
